/** @format */
import React, { useState } from 'react'
import { CustomPageContainer } from 'src/components'
import styled from 'styled-components'
import { _$, Card, Tabs, Tab } from '@king-design/react'
import { useLocation, useHistory } from 'react-router'
import HeaderFilter from 'src/pages/AIObservability/components/HeaderFilter'
import { ServiceOverviewSearchProps } from 'src/pages/AIObservability/components/typescript'
import { initSearch } from 'src/pages/AIObservability/components/constant'
import useNavRegion from 'src/hooks/useNavRegion'
import { AgentKitRuntimeTabType } from '../interface'
import { replaceSearchParams } from 'src/utils'
import AgentKitOverview from '../container/Overview'
import AgentKitRuntimeLLM from '../container/LLM'
import AgentKitRuntimeToken from '../container/Token'
import SessionContainer from 'src/pages/AIObservability/SessionAnalysis/container'
import TraceContainer from 'src/pages/AIObservability/TraceAnalysis/container'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

// 嵌入页面隐藏面包屑
const IS_TOP_WINDOW: boolean = window.self === window.top
const AgentKitRuntimeDetail: React.FC<{ className?: string }> = ({ className }) => {
  const history = useHistory()
  const query = useQuery()
  const location = useLocation()
  const quickKey = query.get('quickKey')
  const startTime = query.get('startTime')
  const endTime = query.get('endTime')
  const runtime = decodeURIComponent(query.get('runtime') || '')
  const serviceName = decodeURIComponent(query.get('serviceName') || '')
  const queryTab = (query.get('tab') as AgentKitRuntimeTabType) || 'overview'
  const [filterSearch, setFilterSearch] = useState<ServiceOverviewSearchProps>(() => {
    const init = initSearch(quickKey)
    if (startTime && endTime) {
      init.time = [parseFloat(startTime), parseFloat(endTime)]
    }
    return init
  })
  const [tab, setTab] = useState<AgentKitRuntimeTabType>(queryTab)

  // 控制台region
  const region = useNavRegion()

  return (
    <div className={className}>
      <CustomPageContainer
        showBack
        onBack={() => {
          history.push('/monitor/agentkit/overview')
        }}
        title={runtime}
        showHeader={IS_TOP_WINDOW}
      >
        <Card type="none">
          <HeaderFilter
            value={filterSearch}
            quickKey={quickKey}
            showAggregate={true}
            onChange={setFilterSearch}
          />
          <Tabs
            className="agentkit-tabs"
            value={tab}
            onChangeValue={v => {
              setTab(v as AgentKitRuntimeTabType)
              replaceSearchParams(history, location, {
                tab: v
              })
            }}
          >
            <Tab value="overview">{_$('运行时总览')}</Tab>
            <Tab value="llm">{_$('LLM性能')}</Tab>
            <Tab value="token">{_$('Token用量')}</Tab>
            <Tab value="session">{_$('会话分析')}</Tab>
            <Tab value="trace">{_$('Trace分析')}</Tab>
          </Tabs>
          {region && tab === 'overview' ? (
            <AgentKitOverview
              quickKey={quickKey}
              serviceName={serviceName}
              step={filterSearch.aggregateType}
              startTime={filterSearch.time[0]}
              endTime={filterSearch.time[1]}
              region={region}
            />
          ) : null}
          {region && tab === 'llm' ? (
            <AgentKitRuntimeLLM
              quickKey={quickKey}
              serviceName={serviceName}
              step={filterSearch.aggregateType}
              startTime={filterSearch.time[0]}
              endTime={filterSearch.time[1]}
              region={region}
            />
          ) : null}
          {region && tab === 'token' ? (
            <AgentKitRuntimeToken
              quickKey={quickKey}
              serviceName={serviceName}
              step={filterSearch.aggregateType}
              startTime={filterSearch.time[0]}
              endTime={filterSearch.time[1]}
              region={region}
            />
          ) : null}
          {region && tab === 'session' ? (
            <SessionContainer
              headerSearch={filterSearch}
              serviceName={serviceName}
              region={region}
            />
          ) : null}
          {region && tab === 'trace' ? (
            <TraceContainer headerSearch={filterSearch} serviceName={serviceName} region={region} />
          ) : null}
        </Card>
      </CustomPageContainer>
    </div>
  )
}

export default styled(AgentKitRuntimeDetail)`
  .agentkit-tabs {
    padding-top: 24px;
    margin-bottom: 24px;
  }
`
